import { Box, Paper, Typography } from '@mui/material';
import { useTenant } from '../models/Hooks';

export function PrivacyPolicyPaper() {
    return <Box sx={{ p: 3, overflow: 'auto', flex: 1 }}>
        <Body />
    </Box>
}

export default function PrivacyPolicy() {
    return <Box sx={{ overflow: 'auto', flex: 1 }}>
        <Body />
    </Box>
}
function Body() {
    const tenant = useTenant();

    const tn = tenant?.Name || 'ЖУК';
    const ukn = tenant?.UKName || 'Организация';

    return <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h1">Политика конфиденциальности мобильного приложения “{tn}”</Typography>
        <Typography variant="body1">
            Настоящая политика конфиденциальности описывает способы сбора, использования, хранения, защиты и раскрытия идентификационных данных пользователей мобильного приложения “{tn}”.
        </Typography>

        <Typography variant="h2">Термины</Typography>
        <Typography variant="body1" component="ul">
            <li>Управляющая компания – {ukn}, осуществляющее услуги по управлению комьюнити {tn}.</li>
            <li>Мобильное приложение – мобильное приложение “{tn}”, используемое в мобильных устройствах (смартфон, планшет и т.п.) на базе операционных систем Android и iOS, позволяющее получать информацию и взаимодействовать с Управляющей компанией.</li>
            <li>Клиент – пользователь Мобильного приложения, являющийся жителем комьюнити {tn}.</li>
            <li>Идентификационные данные – данные, позволяющие идентифицировать Клиента, которые Управляющая компания предоставляет Клиенту.</li>
        </Typography>

        <Typography variant="h2">Сбор, использование и хранение идентификационных данных</Typography>
        <Typography variant="body1">
            Персональные данные, которые отображаются в мобильном приложении, хранятся на серверах и могут быть просмотрены только после прохождения процедуры авторизации. Мобильное приложение может запрашивать доступ к осуществлению телефонных звонков для быстрого набора телефонных номеров сотрудников Управляющей компании.
            При этом персональная информация из телефонной книги устройства Клиента передаваться и сохраняться на сервере Сервиса не будет.
        </Typography>

        <Typography variant="h2">Защита данных</Typography>
        <Typography variant="body1">
            Управляющей компанией предпринимаются все возможные меры для обеспечения безопасности и защиты информации Клиентов от несанкционированных попыток доступа, изменения, раскрытия или уничтожения. В частности:
            <ul>
                <li>Мобильное приложение передает данные по защищенному протоколу HTTPS с использованием действующего сертификата;</li>
                <li>пароли Клиентов хранятся и передаются в зашифрованном виде.</li>
            </ul>
        </Typography>

        <Typography variant="h2">Передача информации третьим лицам</Typography>
        <Typography variant="body1">
            Управляющая компания не разглашает и не передает третьим лицам информацию о личных данных Клиента, полученных с использованием Мобильного приложения, за исключением случаев, предусмотренных действующим законодательством Российской Федерации.
            Изменение Политики конфиденциальности
            Управляющая компания имеет право обновлять и вносить изменения в положения настоящей Политики конфиденциальности в любое время и без предварительного уведомления каких-либо лиц.
        </Typography>
    </Paper>;
}